import { render } from "./StageList.vue?vue&type=template&id=672abdbd&scoped=true"
import script from "./StageList.vue?vue&type=script&lang=js"
export * from "./StageList.vue?vue&type=script&lang=js"

import "./StageList.vue?vue&type=style&index=0&id=672abdbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672abdbd"]])

export default __exports__